import React from 'react'
import './Initials.scss'

export interface IInitialsProps {
  /**
   * Users full name
   */
  fullName: string
  /**
   * Is NameCell completed
   */
  isCompleted?: boolean
  /**
   * Larger version
   */
  size?: 'sm' | 'lg' | 'xl'
  /**
   * Classname
   */
  className?: string
  /**
   * Inline with text
   */
  inline?: boolean
}

export class Initials extends React.PureComponent<IInitialsProps> {
  static defaultProps = {
    inline: true,
  }

  BEM = () => {
    const { isCompleted, size, className, inline } = this.props
    const classArr = ['initials']

    if (isCompleted) {
      classArr.push('initials--active')
    }

    if (inline) {
      classArr.push('initials--inline')
    }

    if (size) {
      classArr.push(`initials--${size}`)
    }

    if (className) {
      classArr.push(className)
    }

    return classArr.join(' ')
  }

  handleInitials = () => {
    const { fullName } = this.props
    const nameArr = fullName.split(' ')

    if (nameArr.length > 1) {
      return nameArr[0].substring(0, 1) + nameArr[nameArr.length - 1].substring(0, 1)
    }

    return nameArr[0].substring(0, 1)
  }

  render() {
    const { fullName } = this.props

    return fullName ? <span className={this.BEM()}>{this.handleInitials()}</span> : null
  }
}
